type IconProps = {
	className?: string;
};
export function InstagramIcon({ className = 'w-6 h-6 text-gray-800 dark:text-white' }: IconProps) {
	return (
		<svg
			className={className}
			aria-hidden='true'
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z'
				clipRule='evenodd'
			/>
		</svg>
	);
}

export function FacebookIcon({ className = 'w-6 h-6 text-gray-800 dark:text-white' }: IconProps) {
	return (
		<svg
			className={className}
			aria-hidden='true'
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='currentColor'
			viewBox='0 0 24 24'
		>
			<path
				fillRule='evenodd'
				d='M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z'
				clipRule='evenodd'
			/>
		</svg>
	);
}

export function ElephantIcon({ className = 'w-6 h-6 text-gray-800 dark:text-white' }: IconProps) {
	return (
		<svg
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='1.8'
			strokeLinecap='round'
			strokeLinejoin='round'
			className={className}
		>
			{/* Back and head bridge */}
			<path d='M 3 19 C 3 15, 4 9, 8 7 C 9 6, 11 6, 13 6 C 16 6, 18 7.5, 19 10' />
			{/* Majestic ear */}
			<path d='M 11 6.5 C 8.5 7, 7 9, 7 12 C 7 15, 8.5 16.5, 10.5 16 C 11.5 15.8, 12 14, 12 11' />
			{/* Upward sweeping trunk - symbol of safe expeditions & good fortune */}
			<path d='M 19 10 C 20 11.5, 21.5 13, 21.5 15.5 C 21.5 17, 20.5 18, 18.5 18 C 16.5 18, 15.5 15.5, 16 13' />
			{/* Ivory Tusk */}
			<path d='M 16.5 13 C 18 13.5, 19 15, 19.5 16' />
			{/* Tusker feet lines */}
			<path d='M 6 19 L 6 15' />
			<path d='M 10 19 L 10 17' />
			<path d='M 14 19 L 14 17' />
			{/* Expressive eye */}
			<circle cx='15.5' cy='9' r='0.75' fill='currentColor' stroke='none' />
		</svg>
	);
}

export function GoogleIcon({ className = 'w-5 h-5' }: IconProps) {
	return (
		<svg className={className} viewBox='0 0 24 24' fill='currentColor'>
			<path
				d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'
				fill='#4285F4'
			/>
			<path
				d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'
				fill='#34A853'
			/>
			<path
				d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z'
				fill='#FBBC05'
			/>
			<path
				d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z'
				fill='#EA4335'
			/>
		</svg>
	);
}
